import { Base } from 'app/components/ui/Base'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { routes } from 'app/routing/routes'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { ResendConfirmUserEmailForm } from './ResendConfirmUserEmail'

export const ResendConfirmUserEmail = (): JSX.Element => {
  return (
    <Base>
      <Container>
        <PageGrid>
          <TextColumn>
            <Text variant='s20'>
              Inserisci l&apos;indirizzo con cui ti sei registrato e riceverai
              una nuova mail da cui potrai confermare il tuo account.{'\n\n'}
              <Link to={routes.login.path}>Torna indietro</Link>
            </Text>
          </TextColumn>
          <FormColumn>
            <ResendConfirmUserEmailForm />
          </FormColumn>
        </PageGrid>
      </Container>
    </Base>
  )
}

const PageGrid = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  display: grid;
  grid-gap: 4rem;

  grid-template-columns: 1fr;

  grid-template-areas:
    'text'
    'form';

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    grid-template-columns: 2fr 1fr 400px 1fr 2fr;

    grid-template-areas:
      '. text text text .'
      '. . form.  .';
  }

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'text form';
  }
`
const TextColumn = styled.div`
  grid-area: text;
`
const FormColumn = styled.div`
  grid-area: form;
`
